import uuid from 'uuid';
import config from '../../../config';
import { createSlice } from '@reduxjs/toolkit';

const notificationLimit = config.notificationOnScreenLimit;

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    queue: []
  },
  reducers:{
    showNotification: (state, action) => {
        const { message, color } = action.payload;
        const guid = uuid();

        const newNotification = {
          guid,
          message,
          color,
        };
        if (state.queue.length > notificationLimit) {
          const arrCopy = state.queue.slice();
          arrCopy.shift();
          arrCopy.push(newNotification);
          state.queue = arrCopy;
        } else {
          state.queue = [...state.queue, newNotification];
        }
    },
    hideNotification: (state, action) => {
        state.queue = 
          state.queue.filter(
            notification => notification.guid !== action.payload,
          );
    }
  }
});

export const { showNotification, hideNotification } = notificationsSlice.actions;

export const queue = state => state.global.notifications.queue;

export default notificationsSlice.reducer;
